import { Stack, useMediaQuery, useTheme } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomDataGrid from "components/customDataGrid";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const McsDetails = ({ data, setData, dialogTitle }) => {
    const theme = useTheme();
    const { bt } = useBizTypeTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const onClose = () => { setData(null) };

    return (
        <CustomDialog width={600} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <Stack>
                <CustomDataGrid
                    maxHeight={450}
                    minHeight={450}
                    borderRadius="10px 10px 10px 10px"
                    columns={[
                        {
                            field: "bizName",
                            headerName: bt("BIZ_NAME"),
                            filterable: true,
                            width: isMobile ? 120 : 200,
                        },
                        {
                            field: "name",
                            headerName: bt("MC_NAME"),
                            filterable: true,
                            width: 120,
                        },
                        {
                            field: "areaName",
                            headerName: bt("AREA"),
                            filterable: true,
                            width: 120,
                        },
                        {
                            field: "softwareType",
                            headerName: bt("SOFTWARE_TYPE"),
                            filterable: true,
                            width: 100,
                        },
                    ]}
                    list={data?.map((item) => ({
                        ...item,
                        id: item._id,
                        bizName: item?.business?.name,
                        areaName: item?.area?.name
                    })) ?? []
                    }
                />

            </Stack>
        </CustomDialog>
    );
};
export default McsDetails;